import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const SearchCategoryRestriction = (params: any): Promise<any> =>
    request({
        url: ApiURL.Query.SearchCategoryRestriction,
        method: RequestType.GET,
        params,
    });

const GetCategoryRestrictionChildren = (params: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetCategoryRestrictionChildren,
        method: RequestType.GET,
        params,
    });

const CategoryRestrictionQuery = {
    SearchCategoryRestriction,
    GetCategoryRestrictionChildren,
};

export default CategoryRestrictionQuery;
